import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import OrderClient from './OrderClient'
import { Button } from 'loyal-react'
import moment from 'moment'
import { push } from 'connected-react-router'

class SuccessStep extends Component {
  constructor (props) {
    super(props)
    this.successGetOrder = this.successGetOrder.bind(this)
    this.goOrderDetailsPage = this.goOrderDetailsPage.bind(this)
    this.loadOrder = this.loadOrder.bind(this)
    this.state = {
      parentOrderId: null,
      orderId: null,
      productId: null,
      date: null,
      operator: null,
      phone: null,
      creditValue: null,
      pointsValue: null,
      loading: true
    }
    this.loadOrder()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.orderId !== this.props.orderId) this.loadOrder()
  }

  loadOrder () {
    if (this.props.orderId) {
      OrderClient.getOrder(this.props.orderId, this.successGetOrder)
    } else {
      this.setState({ order: null })
    }
  }

  successGetOrder (order) {
    let vendorOrder =
      order &&
      order.vendorOrderModel &&
      order.vendorOrderModel.length > 0 &&
      order.vendorOrderModel[0]
    let product =
      vendorOrder &&
      vendorOrder.items &&
      vendorOrder.items.length > 0 &&
      vendorOrder.items[0]

    this.setState({
      parentOrderId: order.parentOrderId,
      orderId: vendorOrder.orderId,
      productId: product.id,
      description: product && product.name,
      date: product && product.deliveryForecast,
      operator: null,
      phone: null,
      creditValue: product && product.rechargeValue,
      pointsValue: product && product.pointsValue,
      loading: false
    })
  }
  goOrderDetailsPage () {
    this.props.goOrderDetailsPage(
      this.state.parentOrderId,
      this.state.orderId,
      this.state.productId
    )
  }

  render () {
    return (
      <div className='bg-white radius row px-2 mx-0 pt-2 pb-3 border-top-lg border-color-success'>
        <div className='row px-1 mx-0'>
          <div className='col-10'>
            <p className='txt-body my-1'>
              <i className='icon icon_check_circle color-success' />
            </p>
          </div>
          <div className='col-2 pl-3'>
            <i
              className='icon icon_close txt-body-sm cursor'
              onClick={this.props.resetSteps}
            />
          </div>
          <div className='col-12'>
            <p className='txt-body my-1 color-success'>
              Parabéns! Seu resgate foi concluído com sucesso.
            </p>
          </div>
          <div className='col-12 my-1'>
            <p className='txt-body-sm'>
              Resgate realizado em:{' '}
              <strong>
                {(this.state.date &&
                  moment(this.state.date).format('DD/MM/YYYY [às] HH[h]mm')) ||
                  '-'}
              </strong>
            </p>
            <p className='txt-body-sm'>
              Descrição: <strong>{this.state.description}</strong>
            </p>
            <p className='txt-body-sm'>
              Valor em créditos: <strong>R$ {this.state.creditValue}</strong>
            </p>
            <p className='txt-body-sm'>
              Valor em reales:{' '}
              <strong>
                {this.state.pointsValue} {this.props.pointsName}
              </strong>
            </p>
          </div>
          <div className='col-12 mt-1 mb-2'>
            <Button
              id={'btnTryAgainRecharge'}
              name={'TryAgainRecharge'}
              className='btn-featured btn btn-sm btn-cart mb-5'
              text='Ver detalhes'
              onClick={this.goOrderDetailsPage}
            />
          </div>
        </div>
      </div>
    )
  }
}

SuccessStep.propTypes = {
  resetSteps: PropTypes.func,
  orderId: PropTypes.number,
  pointsName: PropTypes.string,
  goOrderDetailsPage: PropTypes.func
}

const mapStateToProps = ({
  catalog: {
    currencyConfiguration: { pointsName }
  }
}) => ({
  pointsName
})

const mapDispatchToProps = dispatch => ({
  goOrderDetailsPage: (parentOrderId, orderId, productId) => {
    dispatch(push(`/order/${parentOrderId}/${orderId}/product/${productId}`))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuccessStep)



// WEBPACK FOOTER //
// ./src/features/Services/RechargePhone/SuccessStep/SuccessStep.js